import React from 'react';

/** Phone and email values that open the device dialler or mail app. */
const CrmContactLink: React.FC<{ kind: 'phone' | 'email'; value?: string | null }> = ({ kind, value }) => {
  const text = value?.trim();
  if (!text) return <>—</>;
  const href = kind === 'phone' ? `tel:${text.replace(/[^\d+]/g, '')}` : `mailto:${text}`;
  return <a href={href}>{text}</a>;
};

export default CrmContactLink;
